<template>
    <div v-if="site_info !== null" class="status-bar">
        <div>
            <h2>
                <span class="name">
                    {{site_info.url}} <a v-bind:href="site_info.url" target="_blank"><external-link-icon></external-link-icon></a>&nbsp;
                    <a href="#" v-on:click="copyURL" v-bind:class="{'animated':copy_animated}" v-on:animationend="copy_animated = false"><copy-icon></copy-icon></a>
                </span>
                <span v-if="site_info.server_name != null">[{{alpha_replace[site_info.server_name] + ': ' + site_info.server_name}}]</span>
                <span v-if="site_info.group != null">[ <a href="#">{{site_info.group.name}}</a> ]</span>
                <span v-if="site_info.parsing" class="parsing">Parsing</span>
                <span>Domains(in/out): <span class="ok">{{site_info.domains.in}}</span> / <span class="status">{{site_info.domains.out}}</span></span>
                <template v-if="site_info.moz_rank">
                    <span>DA/PA: <a v-bind:href="['https://analytics.moz.com/pro/link-explorer/overview?site='+site_info.url+'&target=page']" target="_blank" v-bind:title="'Updated: ' + site_info.moz_rank.date">{{site_info.moz_rank.da + ' / ' + site_info.moz_rank.pa}} <external-link-icon></external-link-icon></a></span>
                </template>
            </h2>
            <div>
                last ping: <span v-bind:class="[statusClass(), 'status']">{{site_info.update_ping}}</span>
                vitrins: <span>{{site_info.vitrin_count}}</span>
                last post: <span><time v-bind:datetime="site_info.last_post_date + '00:00:01'">{{site_info.last_post_date}}</time></span>
                <span><a v-bind:href="[site_info.url + '/robots.txt']" target="_blank">robots</a> </span>
                <span><a v-bind:href="[site_info.url + '/robots.txt']" target="_blank">sitemap</a> </span>
                <span><a v-bind:href="['https://analytics.moz.com/pro/link-explorer/spam-score?site='+site_info.url+'&target=page']"
                        target="_blank">SPAM</a> </span>
                <span><a href="#" v-on:click="showLinks">Links</a></span>
            </div>
        </div>
    </div>
</template>
<script>
    import { ExternalLinkIcon, CopyIcon } from 'vue-feather-icons'

    export default {
        components:{
            ExternalLinkIcon,
            CopyIcon
        },
        name: 'StatusBar',
        data: function (){
                return {
                    copy_animated: false,
                    alpha_replace: greck
                }
        },
        props: {
            site_info: Object,
            selected: Object,
            showLinksList: Function
        },
        methods:{
            copyURL: function(){
                this.copy_animated = true;
                copyToClipboard(this.site_info.url);
            },
            showLinks: function(){
                this.showLinksList()
            },
            statusClass: function (){
                if (this.site_info.update_ping == 200){

                    return 'ok';
                }
                return '';
            },
        }
    }
</script>

<style scoped>
    a{
        color: #4e4872;
    }

    a svg{
        -webkit-filter: drop-shadow( 1px 1px 0px rgba(255, 255, 255, 1));
        filter: drop-shadow( 1px 1px 0px rgba(255, 255, 255, 1));
    }

    .parsing{
        animation: fadeInOut 1s infinite;
        color: #ED213A;
    }
</style>
